import React, { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getClaimStageCurrent } from '../../selectors'
import {
  selectStagePlanData,
  selectStagePlanError,
  selectStagePlanIsLoading,
  StagePlanSync as OrdersStagePlan,
} from '../../../../../components/v2/stage-plan'
import { getStagePlanData } from '../../../../../store/stagePlan/action-creators'
import { setStagePlanClear } from '../../../../../store/stagePlan/actions'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'

interface StagePlanProps {
  className?: string
  id: string | number
  hideHeader?: boolean
}

export const StagePlan: React.FC<StagePlanProps> = memo((props: StagePlanProps) => {
  const { className, id, hideHeader } = props
  const dispatch = useAppDispatch()
  const stagePlanIsLoading = useSelector(selectStagePlanIsLoading)
  const stagePlanError = useSelector(selectStagePlanError)
  const stagePlanFiles = useSelector(selectStagePlanData)
  const stage = useSelector(getClaimStageCurrent)

  useEffect(() => {
    let mounted = true
    if (stage !== undefined) {
      if (mounted) {
        dispatch(getStagePlanData('claim', id))
      }
    }
    return () => {
      mounted = false
      dispatch(setStagePlanClear())
    }
  }, [stage, id, dispatch])

  return (
    <OrdersStagePlan
      isLoading={stagePlanIsLoading}
      items={stagePlanFiles}
      error={stagePlanError}
      className={className}
      title={'План исполнения рекламации'}
      emptyMessage={'Прогноз исполнения пуст'}
      typeItem={'claim'}
      hideHeader={hideHeader}
    />
  )
})
